import React, { useState, useEffect } from "react";
import { get } from "lodash";
import { Box, Typography } from "@mui/material";
import ImageMessage from "./Messages/ImageMessage";
import FileInlinePreview from "./Files/FileInlinePreview";

export default function Sender(props) {
	const [animate, setAnimate] = useState(false);
	const { content, files } = props;
	const { type } = content;
	const message = get(content, "config.message", "");
	const link = get(content, "config.link", message);

	let ReplyContent = null;

	switch (type) {
	case "msg":
		ReplyContent = (
			<Typography variant="body1" className="sender-message-text">
				{message}
			</Typography>
		);
		break;
	case "image":
		ReplyContent = <ImageMessage link={link} />;
		break;

	default:
		console.warn(`Unrecognized sender content type: ${type}`);
		break;
	}

	// Animate on what is shown, not on the identity of the object showing it. A message that is
	// re-delivered — a local echo replaced by the record the server confirms, a record refetched
	// after a reconnect — arrives as a new object with the same text, and keying the entrance
	// animation on the object made it play again, dropping the message out and sliding it back in.
	useEffect(() => {
		if (!message && !link) return;
		setAnimate(true);
		const timeout = setTimeout(() => setAnimate(false), 500);
		return () => clearTimeout(timeout);
	}, [type, message, link]);

	return (
		<Box className="sender-ui">
			<Box
				className={`sender-message-container ${animate ? "animate-fade-in-up" : ""
				} ${type === "image" ? "no-bg" : ""}`}
			>
				{ReplyContent}
			</Box>
			{files && files.length > 0 && (
				<FileInlinePreview files={files} />
			)}
		</Box>
	);
}
